<template>
  <v-card v-if="allSpecies" id="species-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="pt-6 pb-4">
      <v-row justify="end">
        <v-col cols="6">
          <v-card outlined>
            <v-card-title class="subtitle-1">
              {{ $t('chosen') }}
            </v-card-title>
            <v-data-table
            fixed-header
            height="max(calc(80vh - 128px), 256px)"
            hide-default-footer
            :items-per-page="-1"
            :items="chosenSpecies"
            :headers="headers"
            dense>
            <template #item.actions="{ item }">
              <v-icon
              small
              color="rgba(0,0,0,0.6)"
              @click="speciesChosen(item)">
                mdi-close
              </v-icon>
            </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card outlined>
            <v-card-title class="subtitle-1">
              {{ $t('available') }}
            </v-card-title>
            <v-data-table
            :loading="predefinedSpeciesLoading"
            fixed-header
            height="max(calc(80vh - 128px), 256px)"
            hide-default-footer
            :items-per-page="-1"
            :items="predefinedSpecies"
            :headers="headers"
            dense>
            <template #item.actions="{ item }">
              <v-icon
              :color="chosenSpecies.some(cs => cs.speciesEnum === item.speciesEnum) ? 'success' : ''"
              @click="speciesChosen(item)">
                {{ chosenSpecies.some(cs => cs.speciesEnum === item.speciesEnum) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-0">
      <v-container fluid class="px-0 pt-0">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn @click="submitClicked" class="primary white--text">{{ $t('save') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProductHeaders from '@/headers/Product'

export default {
  name: 'SpeciesForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  created () {
    this.chosenSpecies = JSON.parse(JSON.stringify(this.allSpecies))
  },

  async mounted () {
    // Statically defined on server. Therefore, do not need to fetch if it's already stored in vuex.
    if (this.predefinedSpecies.length < 1) await this.fetchPredefinedSpecies()
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  data: () => ({
    chosenSpecies: []
  }),

  computed: {
    ...mapGetters('species', ['predefinedSpecies', 'allSpecies', 'predefinedSpeciesLoading']),

    title () {
      return this.$t('defineSpecies')
    },

    headers () {
      return ProductHeaders.speciesHeadersForForm()
    }
  },

  methods: {
    ...mapActions('species', ['createSpecies', 'deleteSpecies', 'fetchPredefinedSpecies']),

    async submitClicked () {
      const speciesToDelete = this.allSpecies
        .filter(s => !this.chosenSpecies.some(cs => s?.speciesEnum === cs?.speciesEnum))
        .map(s => s.speciesId)
      speciesToDelete.forEach(async s => { await this.deleteSpecies(s) })

      const speciesToCreate = this.chosenSpecies
        .filter(cs => !this.allSpecies.some(s => s.speciesEnum === cs.speciesEnum))
        .map(s => s.speciesEnum)
      if (speciesToCreate.length > 0) await this.createSpecies(speciesToCreate)

      this.$emit('species-mutated')
    },

    speciesChosen (species) {
      if (this.chosenSpecies.every(cs => cs.speciesEnum !== species.speciesEnum)) {
        this.chosenSpecies.push(species)
      } else {
        this.chosenSpecies = this.chosenSpecies.filter(cs => cs.speciesEnum !== species.speciesEnum)
      }
    }
  }
}
</script>
